import { useSubscription } from '@apollo/client'
import { captureException, withErrorBoundary } from '@sentry/react'
import { Fragment } from 'react'
import { useHistory } from 'react-router'

import HelpIcon from 'src/assets/help.png'
import SentryFallback from 'src/components/common/SentryFallback'
import MenuPopup from 'src/components/common/menuPopup'
import Spinner from 'src/components/common/spinner'
import { GLEAP_PRODUCT_TOURS } from 'src/schema/subscriptions'
import logger from 'src/utils/logger'

const GleapToursMenu = ({ gleapTours, toursLoading }) => {
    const history = useHistory()

    if (toursLoading) {
        return <Spinner />
    }

    return (
        <>
            <div
                className="w-full bg-neutral-gray-400"
                style={{ overflow: 'auto', maxHeight: '200px' }}
            >
                {gleapTours.map((tour) => {
                    return (
                        <Fragment key={tour.tour_id}>
                            <button
                                className="flex cursor-pointer border-b border-neutral-gray-500 pb-2 pt-2"
                                onClick={() => {
                                    const searchParams = new URLSearchParams({
                                        start_product_tour: true,
                                        tour_id: tour.tour_id,
                                    })

                                    history.push(
                                        `${tour.tour_start_page}?${searchParams.toString()}`
                                    )
                                }}
                            >
                                <div className="pt-1">{tour.tour_name}</div>
                            </button>
                        </Fragment>
                    )
                })}
            </div>
        </>
    )
}

const HelpCenter = () => {
    const { loading: gleapToursLoading, data: gleapToursData } =
        useSubscription(GLEAP_PRODUCT_TOURS, {
            onError: (error) => {
                const errMessage =
                    'An error occurred while fetching `helpCenter.appcuesFlow`'
                logger.error(error)
                logger.error(errMessage)
                captureException(error, {
                    extra: { message: errMessage },
                })
            },
        })

    if (!gleapToursData) {
        return null
    }

    return (
        <>
            <div className="max-w-10 relative mr-2 hidden cursor-pointer lg:inline-flex">
                <MenuPopup
                    menuContent={
                        <GleapToursMenu
                            gleapTours={gleapToursData.tours}
                            toursLoading={gleapToursLoading}
                        />
                    }
                    style={'max-height: 100px'}
                >
                    <div>
                        <img alt="bell" src={HelpIcon} className="h-5 w-5" />
                    </div>
                </MenuPopup>
            </div>
        </>
    )
}

export default withErrorBoundary(HelpCenter, {
    fallback: <SentryFallback />,
})
